import { Controller } from "@hotwired/stimulus"

const WHOLE_PERCENTAGE = 100
const WHOLE_INPUT_CLASSES = ["ring-1", "ring-text-quaternary"]
const ERROR_INPUT_CLASSES = ["ring-2", "ring-text-error", "bg-message-fill-error"]
const WHOLE_TOTAL_CLASS = "text-text-primary"
const ERROR_TOTAL_CLASS = "text-text-error"

export default class extends Controller {
  static targets = ["share", "total"]

  connect() {
    this.check()
  }

  check() {
    const total = this.shareTargets.reduce((sum, input) => sum + (parseFloat(input.value) || 0), 0)
    const whole = Math.abs(total - WHOLE_PERCENTAGE) < 0.001

    this.totalTarget.textContent = `${this.format(total)}%`
    this.totalTarget.classList.toggle(WHOLE_TOTAL_CLASS, whole)
    this.totalTarget.classList.toggle(ERROR_TOTAL_CLASS, !whole)
    this.shareTargets.forEach((input) => {
      WHOLE_INPUT_CLASSES.forEach((name) => input.classList.toggle(name, whole))
      ERROR_INPUT_CLASSES.forEach((name) => input.classList.toggle(name, !whole))
      input.setAttribute("aria-invalid", (!whole).toString())
    })
  }

  format(value) {
    return Number.isInteger(value) ? value.toString() : value.toFixed(2).replace(".", ",")
  }
}
